import { Avatar, Card, Space, Typography } from 'antd'
import './style.scss'
import orgImage from '../../assets/img/organization.png'
import { Link } from 'react-router-dom'
import {
  FacebookOutlined,
  GlobalOutlined,
  InstagramOutlined,
  TwitterOutlined,
} from '@ant-design/icons'
import { DiscordIcon } from '@/assets/icons'
import { svgImage } from '@/assets/svg/svg-icon'

export const OrganizationCard = ({ organization }) => {
  const orgAvatarImage = organization?.avatarUrl
    ? organization?.avatarUrl
    : svgImage.imageNotFound404
  return (
    <Link to={`/dashboard/host-organizations/${organization?.organizationId}`}>
      <Card bordered={false} className="organization-card">
        <Avatar className='organization-avatar' shape="square" src={orgAvatarImage} size={120}></Avatar>
        <Typography.Title
          className='organization-name'
          style={{ whiteSpace: "normal" }}
          level={5}
        >
          {organization?.name}
        </Typography.Title>
      </Card>
    </Link>
  )
}

export const OrgProfile = ({ organization, showSocialIcons = false }) => {
  const orgAvatarImage = organization?.avatarUrl
    ? organization?.avatarUrl
    : orgImage
  return (
    <Space size={20}>
      <Avatar shape="square" src={orgAvatarImage} size={60} />
      <div>
        <Typography.Title level={5}>{organization?.name}</Typography.Title>

        {showSocialIcons && (
          <div className="profile-card">
            {organization?.facebookUrl && (
              <FacebookOutlined
                onClick={() => window.open(organization.facebookUrl, '_blank')}
              />
            )}
            {organization?.instagramUrl && (
              <InstagramOutlined
                onClick={() => window.open(organization.instagramUrl, '_blank')}
              />
            )}
            {organization?.twitterUrl && (
              <TwitterOutlined
                onClick={() => window.open(organization.twitterUrl, '_blank')}
              />
            )}
            {organization?.discordUrl && (
              <div className="discord-icon-container">
                <DiscordIcon
                  onClick={() => window.open(organization.discordUrl, '_blank')}
                />
              </div>
            )}
            {organization?.websiteUrl && (
              <GlobalOutlined
                onClick={() => window.open(organization.websiteUrl, '_blank')}
              />
            )}
          </div>
        )}
      </div>
    </Space>
  )
}
